<fc-general-filter-modal [baseId]="baseId" [form]="form" [fcFilterModalContext]="fcFilterModalContext" (apply)="save()" (cancel)="onCancel()" (clear)="onClear()" [disableClear]="disableClear">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true" (selectedTabChange)="tabChanged($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Filters</span>
        </ng-template>

        <h4>Filters</h4>
        <hr>

        <div class="form-group">
          <label for="{{ baseId }}-id" translate>ID</label>
          <input
            id="{{ baseId }}-id"
            class="form-control"
            type="text"
            formControlName="externalId"
          />
        </div>

        <div class="form-group">
          <label for="{{ baseId }}-name" translate>Name</label>
          <input
            id="{{ baseId }}-name"
            class="form-control"
            type="text"
            formControlName="name"
          />
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-filter-modal>
